const setReleaseState = (mainSettings) => {
  return {
    showDate: mainSettings?.fieldReleaseState === "all",
    showDay:
      mainSettings?.fieldReleaseState === "day_only" ||
      mainSettings?.fieldReleaseState === "all",
  };
};

export { setReleaseState };
